module.exports = __webpack_public_path__ + "static/media/remove_budget_icon_cards.b3cf1713.svg";